import React, { Component } from 'react';
import {Button, Modal } from 'react-bootstrap';
import classes from './modal.module.css';

class popUp extends Component {

  state = { show: false };

  render() {

    const handleShow = () => {
      console.log('attempting to show modal')
      this.setState({ show: true });
    };
  
    const handleClose = () => {
      this.setState({ show: false });
    };

    const Styles = {
        display:"block",
        backgroundColor:"	#6495ED",
        borderRadius: "50%",
        borderWidth: "thin",
        borderColor: "white",
        border: "1px solid",
        padding: "10px",
        boxShadow: "1px 1px 1px #888888"
    }

    return (
      <div>
        <Button
          style={Styles} 
          variant="primary" 
          onClick={handleShow}
          >
          <img src="https://img.icons8.com/android/24/000000/plus.png" alt="buttons"></img>
        </Button>

      <Modal
      dialogClassName={classes.modal}
      show={this.state.show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>NYC-Link</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            NYC-Link was built to help you find linkNYC stations near you.
            Use the map interface to search for a location near you.
          </div>
          <br></br>
           <div>
            <b>Coming soon:</b> NYC-Link 
            allows you to route to the nearest station as well. More features 
            coming soon.
           </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>  
      </div>
    );
  }
}

export default popUp;

/**
 * <Modal show={false} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
 * 
 */